import type { RootState } from "@src/store/rootState";

export const isProductPickerVariantSelected =
  (productId: string | undefined, variantId: string | undefined) =>
  (state: RootState): boolean => {
    if (!productId || !variantId) {
      return false;
    }

    const selectedProduct = state.productPicker.selectedProducts.find(
      (p) => p.id === productId
    );

    if (!selectedProduct) {
      return false;
    }
    if (!selectedProduct.selectedVariantIds) {
      return true;
    }

    return selectedProduct.selectedVariantIds.includes(variantId);
  };
